module.exports = __webpack_public_path__ + "img/31.92999c76.jpg";